import type { NavigateFunction } from 'react-router-dom'

interface UseResumeHandlerParams {
    mostRecentStory: { storyId: string; storyTitle: string } | null
    onClose?: () => void
    /** Navigation function (required for dependency injection) */
    navigate: NavigateFunction
}

export const useResumeHandler = ({
    mostRecentStory,
    onClose,
    navigate,
}: UseResumeHandlerParams) => {
    const handleResumeClick = () => {
        if (!mostRecentStory) return

        void navigate(`/lesson?story_id=${mostRecentStory.storyId}`)
        onClose?.()
    }

    return { handleResumeClick }
}
